import { reactive, ref } from 'vue';

export function useModal() {
  const type = ref(null);
  const data = ref({});
  const context = ref({});
  const isEditing = ref(false);
  const processing = ref(false);
  const disabled = ref(false);

  const open = (modalType, payload, extraContext = {}) => {
    type.value = modalType;
    context.value = extraContext;

    // Deep clone to prevent direct mutation
    data.value = JSON.parse(JSON.stringify(payload));

    // check if id exists
    isEditing.value = !!(data.value && data.value.id);

    if (extraContext.isEditing) {
      isEditing.value = extraContext.isEditing;
    }
  };

  const close = () => {
    type.value = null;

    setTimeout(() => {
      data.value = {};
      isEditing.value = false;
      context.value = {};
      processing.value = false;
      disabled.value = false;
    }, 200);
  };

  return reactive({
    type,
    data,
    context,
    isEditing,
    processing,
    disabled,
    open,
    close,
  });
}
